import Image from 'next/image';
import i18n from '@/settings/i18n';
import { ComplianceInfoT } from '../constants';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const t = i18n.init('product');

const ComplianceContent = ({ info }: { info: ComplianceInfoT }) => (
  <div className="flex h-full flex-col text-sm">
    <div className="space-y-6 bg-[#F9F9F9] p-6">
      <div>
        <h3 className="font-bold">{t`Manufacturer`}</h3>
        <p>{info.manufacturer}</p>
      </div>
      <div>
        <h3 className="font-bold">{t`Brand`}</h3>
        <p>{info.brand}</p>
      </div>
      <div>
        <h3 className="font-bold">{t`Contact`}</h3>
        <p>{info.contact}</p>
      </div>
      <div>
        <h3 className="font-bold">{t`Address`}</h3>
        <p>{info.address}</p>
      </div>
    </div>
    <div className="px-6">
      <div className="py-8">
        <h3 className="text-base font-bold">
          {t`Responsible Operator in the EU`}
        </h3>
        <p>{t`The seller hasn’t provided this information yet.`}</p>
      </div>
      <hr />
      <div className="py-8">
        <div className=" rounded-md border border-[#E4F1FF] bg-gradient-to-br from-[#E4F0FF] to-[#FBFDFF] p-6">
          <h3 className="flex items-center gap-2 text-base font-bold text-[#0052B4]">
            <Image
              alt={t`European Union`}
              src={getEdgeUrl('icons/flags/eu.png')}
              height={50}
              width={50}
              className="h-5 w-5"
            />
            {t`Seller Certification`}
          </h3>
          <h4 className="mt-4 font-bold">{t`European standards compliant`}</h4>
          <p className="mt-2">
            {t`The Seller has self-certified to only offer devices that comply with the applicable rules of EU law.`}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ComplianceContent;
